
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { useIncognitoBrowsing } from "@/hooks/useIncognitoBrowsing";

export const useProfileViews = () => {
  const { user } = useAuth();
  const { isIncognitoEnabled } = useIncognitoBrowsing();
  const [viewedProfiles, setViewedProfiles] = useState<string[]>([]);

  const handleProfileView = async (viewedUserId: string) => {
    if (!user || viewedProfiles.includes(viewedUserId)) return;
    
    try {
      await supabase
        .from('profile_views')
        .insert({
          viewer_id: user.id,
          viewed_id: viewedUserId,
          is_anonymous: isIncognitoEnabled
        });
      
      setViewedProfiles(prev => [...prev, viewedUserId]);
      console.log('Profile view tracked for user:', viewedUserId, isIncognitoEnabled ? '(incognito)' : '');
    } catch (error) {
      console.error('Error tracking profile view:', error);
    }
  };

  return {
    viewedProfiles,
    handleProfileView
  };
};
